import DescriptionTablet from './DescriptionTablet';

export default DescriptionTablet;
export { DescriptionTablet };
